export default class erbMiFIDFieldAnswer extends React.Component {
	render() {
		let answer = StringUtils.process(this.props.currentValue, {...this.props});
		if (answer == 'None') {
			return (<span>&#010;&#010;</span>);
		} else if (answer == 'NotDefined') {
			return (<span className="MiFIDField">&#010;    <span className='questionMark'>?</span>&#010;  </span>);
		} else if (answer == 'HaveKnowExpe' || answer == 'HaveKnowledgeExperience') {
			return (<span className="MiFIDField">&#010;      <i className="tc-icon icon-accept" title="Have knowledge and experience"><span></span></i>&#010;    </span>);
		} else if (answer == 'HaveKnowledge') {
			return (<span className="MiFIDField">&#010;      <i className="tc-icon icon-information" title="Have knowledge, but no experience" style={{color: '#2f68da'}}><span></span></i>&#010;    </span>);
		} else {
			return (<span className="MiFIDField">&#010;      <i className="tc-icon icon-cancel" title="No knowledge, no experience"><span></span></i>&#010;    </span>);
		}
	}
}

UXPComponentFactory.add("erbMiFIDFieldAnswer", erbMiFIDFieldAnswer);